import * as Sentry from "@sentry/react";
import { BUILD_ID } from "@/lib/version";

if (typeof window !== "undefined") {
  Sentry.init({
    dsn: "https://9ac26c923ed358aeb7521a2207ba169f@o4511100102180864.ingest.us.sentry.io/4511100106702848",
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
    // Matches the release the sentry-vite-plugin uploads symbols against
    // (vite.config.ts passes the same BUILD_ID via `release.name`). Error
    // reports + source maps stay aligned, and we know exactly which build
    // a user was running when something fired.
    release: BUILD_ID,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export { Sentry };
